"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledTerm = _styledComponents["default"].dt.withConfig({
  displayName: "Term__StyledTerm",
  componentId: "sc-19p28wl-0"
})(function (props) {
  return (0, _styledComponents.css)(["font-family:", ";padding:", ";margin:", ";"], props.theme.font.family, _units.globalSizes.small, _units.globalSizes.small);
});
/**
 *
 * ### Term Component

Term component is a styled description Term```<dt>``` HTML element. It needs to be used inside Summary, which is a Component Description List element ``<dl>``, usually followed by a Description Component ``<dd>``.

```html
<Summary label={'Summary'}>

  <Term>

      Term

  </Term>

  <Description>

      Description

  </Description>

</Summary>```

The output would be rendered as standard HTML elements.

```html
<dl>

  <dl>

      Term

  </dl>

  <dd>

      Description

  </dd>

</dl>```
 */


var Term = function Term(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledTerm, null, children);
};

var _default = Term;
exports["default"] = _default;